import { render, staticRenderFns } from "./select_index.vue?vue&type=template&id=3250e67e&scoped=true"
import script from "./select_index.vue?vue&type=script&lang=js"
export * from "./select_index.vue?vue&type=script&lang=js"
import style0 from "./select_index.vue?vue&type=style&index=0&id=3250e67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250e67e",
  null
  
)

export default component.exports